import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Col } from 'react-bootstrap';
import ToolTipV1 from 'lib/TooltipV1';
import determineRequired from 'helper/validateRequired';
import { compareData } from "helper/calculateNetAsset";
const Label = (props) => {  
  const [requiredFields, setRequiredFields] = useState(null); // Initialize state
  const workflowUser = useSelector((state) => state.userInfo?.workflowUser);
  const selectedData = useSelector((state) => state.formData?.selectedData);
  const staticData = useSelector((state) => state.staticData);
  const recursiveFormData = useSelector(
    (state) => state.recursive?.recursiveFormData
  );
  const vkycCallback = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo?.vcip_callback
  );
  const popupReducer = useSelector((state)=> state.popupReducer);
  const config = useSelector(
    (state) => state?.configurationReducer?.config?.wf_journey
  );
  const subworkflowInfo = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo
  );
  const recursive = useSelector((state)=>state?.recursive)
  const assign_approval_to = useSelector((state)=>state?.dashboardDetailReducer?.dashboardDetailData?.primaryworkflow?.source_data?.assign_approval_user_id);
  const assigned_dynamic_step = useSelector((state)=>state?.dashboardDetailReducer?.dashboardDetailData?.primaryworkflow?.source_data?.assigned_dynamic_step)

  const { label, htmlFor, className, tooltip, validators, digilocker, isToggle,approval_type,size } = props;
  const IndirectEval = (evalString) =>{
    return eval(evalString)
}

  const validateFields = async () => {
    return await determineRequired(subworkflowInfo, config, subworkflowInfo?.step_history,assign_approval_to,assigned_dynamic_step);
  };

  const checkStatus = (value_1,value_2,arr) => {
    return compareData(value_1,value_2,arr)
  }
  const processValidators = async () => {
    if (approval_type == "parallel") {
      const res = await validateFields();
      setRequiredFields(res);
    } else {
      if (validators?.required === undefined) {
        setRequiredFields(true);
      } else {
        setRequiredFields(IndirectEval(validators?.required));
      }
    }
  };

  useEffect(() => {
    processValidators();
  }, [validators, subworkflowInfo, config]); 




  return (
    <>
      {(!digilocker && ((recursive?.showDataPreview  && recursive?.showRecursiveForm == false ) ?  !(Array.isArray(recursive?.showData.length > 0) || Object.keys(recursiveFormData).length !== 0 ) : true )) ? (
        <Col xs={12} md={12} lg={isToggle ? 10 : 12} className={`${size}`}>
          <label className={`form-label mb-2 mt-2 ${className}`} htmlFor={htmlFor} style={{ className }}>
            {label} 
            {(IndirectEval(validators?.required) || requiredFields )? "" : " (Optional)"}
            {tooltip?.map((item, index) => (
              <ToolTipV1 
                key={index}
                trigger={item?.trigger} 
                type={item?.alert_type} 
                tooltipText={item?.tooltip_text} 
                show={item?.show}
              />
            ))}
          </label>
        </Col>
      ) : ("")}
    </>
  );
};

export default Label;
